import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import DocumentTitle from 'react-document-title'

import AccountsOfficesTable from './AccountsOfficesTable'
import Error from '@components/Error/NoContent'
import Spinner from '@components/spinner'
import Pagination from '@components/Pagination'

class AccountsOfficesTab extends Component {
  static propTypes = {
    parentAccount: PropTypes.object,
    accountsAndOfficesStore: PropTypes.object
  }

  constructor (props) {
    super(props)
    const { parentAccount, accountsAndOfficesStore } = props

    accountsAndOfficesStore.loadAccounts(parentAccount.id)
  }

  render () {
    const {
      accounts,
      error,
      loading,
      accountsCount,
      accountsPerPage,
      page,
      paginateAccounts
    } = this.props.accountsAndOfficesStore

    const { parentAccountName } = this.props.parentAccount

    if (error) {
      return <Error />
    }

    if (loading) {
      return <Spinner />
    }

    return (
      <DocumentTitle
        title={`${parentAccountName} - accounts & offices | Atheneum Partners`}
      >
        <div className='accountsoffices-wrapper'>
          <AccountsOfficesTable accounts={accounts} />

          <Pagination
            total={accountsCount}
            perPage={accountsPerPage}
            page={page}
            onChange={paginateAccounts}
          />
        </div>
      </DocumentTitle>
    )
  }
}

export default inject('accountsAndOfficesStore')(observer(AccountsOfficesTab))
